import {Button, Modal} from "react-bootstrap";
import {mediumTextStyles, regularTextStyles} from "../Style";
import {useCookies} from "react-cookie";
import Cookies from "js-cookie";

function SessionExpirePopup(props) {
  const [cookie, setCookie] = useCookies(['jwt-token']);
  const handleClose = () => {
    props.handleChangeValue('sessionTimeout', props.inputValues.sessionTimeout + 1);
    let jwt = Cookies.get('jwt-token');
    setCookie('jwt-token', jwt, {
      path: '/',
      maxAge: props.inputValues.sessionTimeout
    });
    props.handleChangeValue('showCookieExpiryPopup', false);
    props.handleChangeValue('expireSession', false);
  };


  return (
    <>

    <Modal
        show={props.inputValues.showCookieExpiryPopup}
        onHide={handleClose}

        backdrop="static"
        size="lg"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title style={mediumTextStyles}><span style={{color: 'red'}}>Session Expiry</span> </Modal.Title>
        </Modal.Header>

        <Modal.Body style={regularTextStyles}>
          <p>
            Your session is about to expire. Would you like to extend this session?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Extend Session
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SessionExpirePopup;
